import React, { Component } from "react";

class title_a extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: "0px"
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      width: nextProps.width
    });
  }

  render() {
    return (
      <header
        style={{
          width: this.state.width,
          height: "54px",
          background: "#F7D722",
        }}
      >
        <center style={styles.titleText}>
          Alpha<b>ML</b>
        </center>
      </header>
    );
  }
}

const styles = {
  titleText: {
    paddingTop: "8px",
    fontFamily: "Helvetica",
    fontSize: "18px",
    color: "#232D43",
    display: "flex",
    justifyContent: "center",
  }
};
export default title_a;
